import React from "react";
import { connect } from "react-redux";
import VendorContent from "containers/request/RequestContent/VendorContent";
import reqTypes from "dictionaries/ReqTypes";
import { batteryTabsHRR, batteryTabsEcoHRR } from "helpers/RequestTabsHelper";
import {
  getChecklistInitialHRR,
  getChecklistEcoHRR
} from "helpers/ChecklistBatteryHelper";

const RequestContentHRR = ({ request, focusLab }) => {
  const checkListInitial = getChecklistInitialHRR(request);
  const checkListECO = getChecklistEcoHRR(request);

  switch (request.type) {
    case reqTypes.initial:
      return (
        <VendorContent
          tabs={batteryTabsHRR}
          checkList={checkListInitial}
          defaultTab={focusLab ? "labInfo" : "deviceInfo"}
        />
      );
    case reqTypes.eco:
      return (
        <VendorContent
          tabs={batteryTabsEcoHRR}
          checkList={checkListECO}
          defaultTab={focusLab ? "labInfo" : "deviceInfo"}
        />
      );
    default:
      return null;
  }
};

function mapStateToProps({ request }) {
  return { request };
}

export default connect(mapStateToProps)(RequestContentHRR);
